import { DataTable } from "../components/DataTable";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { InfoSection } from "../components/InfoSection";
import { MainContainer } from "../components/MainContainer";

export const Certification = () => {
  return (
    <MainContainer>
      <Header />
      <InfoSection />
      <DataTable />
      <Footer />
    </MainContainer>
  );
};
